import { UseSelectionResult } from '../hooks';
import { FeatureConfiguration } from '@features/tableEngine/types';
import { Share1Icon, Share2Icon, TrashIcon } from '@radix-ui/react-icons';
import { Flex } from '@radix-ui/themes';
import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { TableBulkActions } from './TableBulkActions';
import { TableSelectionControl } from './TableSelectionControl';

import styles from './SelectionRow.module.css';

interface SelectionRowProps<TData extends { id: string }> {
    table: Table<TData>;
    selection: FeatureConfiguration<TData>['selection'];
    selectionState: UseSelectionResult<TData>;
}

export const SelectionRow = <TData extends { id: string }>({
    table,
    selectionState,
    selection,
}: SelectionRowProps<TData>) => {
    const { t } = useTranslation('table');

    return (
        <Flex align={'center'} gap={'3'}>
            {selection.enabled && (
                <TableSelectionControl
                    table={table}
                    selectionState={selectionState}
                    displayKey={selection.displayKey}
                />
            )}

            <Flex
                align='center'
                gap='3'
                flexShrink={'0'}
                className={styles.animatedContainer}
            >
                {/* {selection.summaryKey && (
                    <SelectionSummary
                        items={Object.values(selectionState.selectedItems)}
                        summaryKey={selection.summaryKey}
                    />
                )} */}

                <TableBulkActions
                    selectionState={selectionState}
                    actions={[
                        {
                            label: t('actions.delete'),
                            onClick: (items: TData[]) => {
                                console.log('Delete these:', items);
                            },
                            color: 'ruby',
                            icon: <TrashIcon />,
                        },
                        {
                            label: t('actions.export'),
                            onClick: (items: TData[]) => {
                                console.log('Export these:', items);
                            },
                            color: 'grass',
                            icon: <Share2Icon />,
                        },
                        {
                            label: t('actions.share'),
                            onClick: (items: TData[]) => {
                                console.log('Share these:', items);
                            },
                            color: 'indigo',
                            icon: <Share1Icon />,
                        },
                    ]}
                />
            </Flex>
        </Flex>
    );
};
